// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import {
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Avatar,
} from "@mui/material";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { de } from "date-fns/locale";
import { styled } from "@mui/material/styles";
import parse from "html-react-parser";
import {
  LocalFireDepartment,
  Masks,
  Construction,
  Event,
  EmojiEventsOutlined as Competition,
  School,
  HomeWork,
} from "@mui/icons-material";

const StyledLink = styled((props) => <Link {...props} />)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export default function ActivityItem(props) {
  const {
    title,
    date,
    type,
    content,
    imageRegex,
    firstImageNr,
    lastImageNr,
    cardImageNr,
    cardType,
    video,
  } = props.activityData;

  const showVideo =
    cardType === "undefined" ? false : cardType === "video" ? true : false;

  const showMoreImages =
    firstImageNr === "undefined"
      ? false
      : lastImageNr === "undefined"
      ? false
      : firstImageNr !== undefined && video !== undefined
      ? true
      : firstImageNr !== "undefined" &&
        lastImageNr !== "undefined" &&
        firstImageNr === lastImageNr
      ? false
      : true;

  return (
    <Card sx={{ height: "100%" }}>
      <CardHeader
        id={format(date, "yyyyMMddHH", { locale: de })}
        avatar={
          type === "Übung" ? (
            <HomeWork />
          ) : type === "Brandeinsatz" ? (
            <LocalFireDepartment />
          ) : type === "Schadstoffeinsatz" ? (
            <Masks />
          ) : type === "Technischer Einsatz" ? (
            <Construction />
          ) : type === "Veranstaltung" ? (
            <Event />
          ) : type === "Bewerb" ? (
            <Competition />
          ) : type === "Schulung" ? (
            <School />
          ) : (
            <Avatar>{type.substring(0, 1)}</Avatar>
          )
        }
        title={title}
        subheader={format(date, "dd. MMMM yyyy", { locale: de })}
      />

      {typeof content !== "undefined" &&
        showVideo === true &&
        video !== "undefined" && (
          <video
            width="100%"
            controls>
            <source
              src={process.env.PUBLIC_URL + video}
              type="video/mp4"
            />
          </video>
        )}
      {typeof content !== "undefined" &&
        typeof imageRegex !== "undefined" &&
        showVideo === false && (
          <Link
            to={"/Aktivitaeten/" + format(date, "yyyyMMddHH", { locale: de })}
            state={{
              startImageGallery: false,
            }}>
            <CardMedia
              component="img"
              image={
                process.env.PUBLIC_URL + imageRegex.replace("*", cardImageNr)
              }
              alt=""
            />
          </Link>
        )}
      {typeof content !== "undefined" && (
        <CardContent
          sx={(theme) => ({
            fontFamily: theme.typography.body2.fontFamily,
            fontWeight: theme.typography.body2.fontWeight,
            fontSize: theme.typography.body2.fontSize,
            lineHeight: theme.typography.body2.lineHeight,
            letterSpacing: theme.typography.body2.letterSpacing,
          })}>
          {parse(content)}{" "}
          {showMoreImages && (
            <StyledLink
              to={"/Aktivitaeten/" + format(date, "yyyyMMddHH", { locale: de })}
              state={{
                startImageGallery: false,
              }}>
              Weitere Fotos
            </StyledLink>
          )}
        </CardContent>
      )}
    </Card>
  );
}
